

















export default {
  name: 'blog',
  data() {
    return {};
  },
  props: {
    articles: Array,
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/page/blog/list/List.vue